import React from 'react';
import { FallbackProps } from 'react-error-boundary';
import { Alert, AppLayout, Button } from '@amzn/awsui-components-core';
import { OESideNavigation } from '../fintech-ops-dashboard/OESideNavigation';

export const OEErrorFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  return (
    <AppLayout
      navigation={<OESideNavigation />}
      toolsHide
      content={
        <Alert
          type="error"
          dismissible={false}
          visible={true}
          header="Something Went Wrong"
          action={<Button onClick={resetErrorBoundary}>Try Again</Button>}
        >
          {error?.message || 'An unexpected error occurred.'}
        </Alert>
      }
    />
  );
};
